module.exports = __webpack_public_path__ + "static/media/chat_image.f1e457f7.png";